;globalThis["_sentryRewritesTunnelPath"] = undefined;globalThis["SENTRY_RELEASE"] = {"id":"1248160ca82f710a8d92b0856d8e4cda0482a60a"};globalThis["_sentryBasePath"] = undefined;globalThis["_sentryRewriteFramesAssetPrefixPath"] = "";import * as Sentry from '@sentry/nextjs';

import { CORE_ERROR_PATTERNS, createBeforeSend } from '@zep/sentry';

import baseOptions from '../../sentry.base.config';

Sentry.init({
  ...baseOptions,
  beforeSend: createBeforeSend({
    ignorePatterns: [...CORE_ERROR_PATTERNS],
  }),
});
